/**
 * Load the Event photo carousel
 */

import bulmaCarousel from '../../../../Public/Frontend/node_modules/bulma-carousel/src/js/index.js';

bulmaCarousel.attach('.carousel__content', {
	pagination: false,
	slidesToShow: 1,
	infinite: true,
	autoplay: true,
	breakpoints: [],
});
